import { AppState } from "../../../../redux-configuration/AppState";

export const loadingSendBroadcastMessageSelector = (appState: AppState): boolean => appState.messaging.broadcast.send.loading
export const errorSendBroadcastMessageSelector = (appState: AppState): string | undefined => appState.messaging.broadcast.send.error
export const successSendBroadcastMessageSelector = (appState: AppState): boolean | null => appState.messaging.broadcast.send.success
